// extracted by mini-css-extract-plugin
export default {"menuButton":"menuButton__vMmLBi","menuIcon":"menuIcon__ql3XNy"};